import { Component, OnInit } from '@angular/core';
import { UserService } from 'src/app/shared/user.service';
import { Router } from '@angular/router';

@Component({
  selector: 'app-success',
  templateUrl: './success.component.html',
  styleUrls: ['./success.component.css']
})
export class SuccessComponent implements OnInit {

  constructor(public userService: UserService,private router: Router) {
    if(!this.userService.onboardingDone){
      this.router.navigate(['app/onboarding']);
    }
   }

  ngOnInit(): void {
  }

}
